var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-clamp',{staticClass:"clamp-container",attrs:{"autoresize":"","max-lines":_vm.maxLines},scopedSlots:_vm._u([{key:"after",fn:function(ref){
var toggle = ref.toggle;
var expanded = ref.expanded;
var clamped = ref.clamped;
return [(expanded || clamped)?_c('a-button',{staticClass:"link",attrs:{"type":"link"},on:{"click":toggle}},[_vm._v(_vm._s(expanded ? '收起' : '展开'))]):_vm._e()]}}])},[[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }